import HeaderNavBar from "./Components/Header/header";
import SubscribepopupModel from "./Components/Subscribe Popup/subscribepopup";
import AllRoutes from "./Routes/allRoutes";
import { ToastContainer } from "react-toastify";


function App() {
  return (
    <div className="">
      <HeaderNavBar />
      <AllRoutes />
      <SubscribepopupModel />
      <ToastContainer
        position="bottom-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      ></ToastContainer>
    </div>
  );
}

export default App;
